export default function createElement<E extends HTMLElement>(
  tag: string,
  attr: Record<string, string | unknown> = {},
  children: string | HTMLElement | HTMLElement[] = '',
  options = { isChildrenHTMLString: false }
): E {
  const element = document.createElement(tag) as E;

  Object.entries(attr ?? {}).forEach(([key, value]) => {
    if (typeof value === 'string') {
      element.setAttribute(key, value);
    }
  });

  if (typeof children === 'string') {
    if (options?.isChildrenHTMLString) {
      element.innerHTML = children;
    } else {
      element.innerText = children;
    }
  } else {
    element.append(...[children].filter(Boolean).flat());
  }

  return element;
}
